export const normalizeCampaignUuid = (value) => {
  if (value == null || value === '') return null
  return String(value).trim().toLowerCase()
}

export const parseKnownNumericValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export const parseCampaignPageResponse = (response) => {
  const returned = response?.data
  const items = Array.isArray(returned)
    ? returned
    : (returned?.items || returned?.data || [])

  const totalFromBody = returned?.total || returned?.meta?.total || returned?.count
  const totalFromHeader = response?.headers?.['x-total-count']
    ? parseInt(response.headers['x-total-count'], 10)
    : null
  const total = totalFromBody ?? totalFromHeader ?? null

  return { items, total }
}

export const getCampaignHistoryItemId = (campaign = {}) =>
  normalizeCampaignUuid(campaign?.uuid || campaign?.campaignArtGenerationId || campaign?.id)

export const CAMPAIGNS_PAGE_SIZE = 10
